export default "__VITE_ASSET__vzd7plDC__"